import * as React from 'react'

import { type IFilterMode, SingleSelectFilter } from '@user/components/Filters'

import { ActivityTypeProvider } from './Provider'

export function ActivityTypeFilter(props: IFilterMode) {
  return (
    <SingleSelectFilter
      {...props}
      name="activityTypeId"
      label="Activity Type"
      component={ActivityTypeProvider}
    />
  )
}
